import { render, staticRenderFns } from "./PostCodeInputWidget.vue?vue&type=template&id=5a3dadf4&scoped=true"
import script from "./PostCodeInputWidget.vue?vue&type=script&lang=js"
export * from "./PostCodeInputWidget.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5a3dadf4",
  null
  
)

export default component.exports